import { Flex, Spinner, Text } from "@radix-ui/themes";

export function KioskLoading() {
  return (
    <Flex className="h-dvh" align="center" justify="center" gap="3">
      <Spinner size="3" />
      <Text color="gray">Starting kiosk…</Text>
    </Flex>
  );
}
